import { createI18n } from "vue-i18n";
import frfr from "./languages/fr-FR.json";
// import config from "../env/index";
import dateFr from "./dates/fr.json";
import { bisomI18n } from "@bisom/web_package";

function jsonConcat(o1: Record<string, object>, o2: Record<string, object>) {
  for (const key in o2) {
    o1[key] = { ...o1[key], ...o2[key] };
  }
  return o1;
}

const bindingTranslations = {
  fr: jsonConcat(frfr, bisomI18n.fr_fr),
  "en-US": {},
};

const datetimeFormats = {
  fr: dateFr,
  "en-US": {},
};

const params = {
  locale: "fr",
  legacy: false,
  useScope: "global",
  globalInjection: true,
  fallbackLocale: "fr",
  messages: bindingTranslations,
  datetimeFormats,
};

const i18n = createI18n(params);

const global = i18n.global;
const { t, d } = global;

export const $t = t;
export const $d = d;
export default i18n;
